import React from "react";
import Text from "../../../common/typography/text.js";
import { formatGrowth } from "../aabiFormatters";
import "./../AABI.css";

// Deterministic Key Drivers (§6.3): transparent rules over the currently
// loaded child rows, computed from the selected measure. Any insight not
// supported by the data is omitted rather than overstated.
const KeyDrivers = ({ drivers }) => {
  if (!drivers) {
    return (
      <div className="aabi-key-drivers">
        <Text variant="smallText" color="lightText">
          Not enough contributor data to compute drivers for this scope.
        </Text>
      </div>
    );
  }

  const nameOf = (row) =>
    row.code ? `${row.name} (${row.code})` : row.name;
  const growthTone = (growth) =>
    growth > 0 ? "positive" : growth < 0 ? "negative" : "neutral";

  // Each driver splits into the entity (what) and a headline metric (how much)
  // so the number can lead and carry the semantic colour.
  const chips = [
    drivers.largest && {
      key: "largest",
      label: "Largest contributor",
      name: nameOf(drivers.largest),
      metric: `${(drivers.largest.selectedShare * 100).toFixed(1)}%`,
      caption: "of level total",
      tone: "primary",
    },
    drivers.fastestGrowing && {
      key: "growing",
      label: "Fastest growth",
      name: nameOf(drivers.fastestGrowing),
      metric: formatGrowth(drivers.fastestGrowing.growth),
      caption: "vs prior period",
      tone: growthTone(drivers.fastestGrowing.growth),
    },
    drivers.largestDecliner && {
      key: "declining",
      label: "Largest decline",
      name: nameOf(drivers.largestDecliner),
      metric: formatGrowth(drivers.largestDecliner.growth),
      caption: "vs prior period",
      tone: growthTone(drivers.largestDecliner.growth),
    },
    {
      key: "concentration",
      label: "Top-3 concentration",
      name: "Top three contributors",
      metric: `${(drivers.topThreeShare * 100).toFixed(1)}%`,
      caption: "of revenue",
      tone: "neutral",
    },
  ].filter(Boolean);

  return (
    <div className="aabi-key-drivers" aria-label="Key drivers">
      {chips.map((chip) => (
        <div
          key={chip.key}
          className={`aabi-driver-chip aabi-driver-chip--${chip.tone}`}
        >
          <Text variant="tinyText" color="lightText">
            {chip.label}
          </Text>
          <span className="aabi-driver-name" title={chip.name}>
            <Text variant="smallText">{chip.name}</Text>
          </span>
          <div className="aabi-driver-metric-row">
            <Text variant="numberBig" className="aabi-driver-metric">
              {chip.metric}
            </Text>
            <Text variant="tinyText" color="lightText">
              {chip.caption}
            </Text>
          </div>
        </div>
      ))}
    </div>
  );
};

export default KeyDrivers;
